import styled, { css } from 'styled-components'

import { Text } from '@interco/inter-ui/components/Text'

export const headerStyles = css``
// 100vw = 16    logo
export const Container = styled.div`
  width: 100vw;
  height: 56.25vw !important;
  min-height: 56px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: var(--neutral-theme);
  padding: 0;
  top: 0;
  left: 0;
`

export const Title = styled(Text).attrs({
  color: 'typography',
  variant: 'headline-h3',
  semiBold: true,
})`
  align-self: center;
  margin: auto;
`
